import { call, fork, put, takeLatest } from 'redux-saga/effects';

import * as types from 'constants/ActionTypes';

import * as tvaActions from '../actions/tvaActions';
import TvaService from '../services/api/TvaService';

/* Get */
function* fetchTvaValuesWatcher() {
  yield takeLatest(types.FETCH_TVA_VALUES_REQUEST, fetchTvaValues);
}

function* fetchTvaValues() {
  try {
    const response = yield call(TvaService.getTvaValues);
    yield put(tvaActions.fetchTvaValuesSuccess(response.data));
  } catch (e) {
    yield put(tvaActions.fetchTvaValuesFailure(e));
  }
}

const tvaSagas = [fork(fetchTvaValuesWatcher)];

export default tvaSagas;
